import React, { useEffect } from 'react';
import { useHistory, NavLink } from 'react-router-dom';
import authService from '../../services/authServices';
import AppConstants from '../../appConstants';
import logo from '../../adminAssets/images/Lovrican-Logo_2.svg';
import drawerIcon from '../../adminAssets/images/Lovrican-Drawer.svg';
import homeIcon from '../../adminAssets/images/Home.svg';
import overdueIcon from '../../adminAssets/images/Overdue.svg';
import eyeIcon from '../../adminAssets/images/dashbaord_eye_upcomming.svg';
import futureIcon from '../../adminAssets/images/Future.svg';
import paidIcon from '../../adminAssets/images/Paid.svg';
// HIDDEN FOR NOW: only the AFFILIATES section of the menu used these icons.
// import recentProfileIcon from '../../adminAssets/images/recent_profile.svg';
// import requestedInfoIcon from '../../adminAssets/images/requested_info.svg';
// import approvedIcon from '../../adminAssets/images/approved.svg';
// import suspendedIcon from '../../adminAssets/images/suspended.svg';
// import deleteIcon from '../../adminAssets/images/delete.svg';
// import rejectedIcon from '../../adminAssets/images/rejected.svg';
import logoutIcon from '../../adminAssets/images/dashbaord_signout.svg';

const AdminLeftMenu = (props) => {
  const { leftMenuToggleHandler, isLeftMenuVisible, isMobileView } = props;
  const { logoutAdmin } = authService;
  const history = useHistory();

  // Get user role from localStorage
  const getUserRole = () => {
    try {
      const userDetails = localStorage.getItem('userDetails');
      if (userDetails) {
        const parsed = JSON.parse(userDetails);
        return parsed.role || null;
      }
    } catch (error) {
      // Corrupt localStorage should not blank the admin menu; log and fall
      // through to the null role below.
      // eslint-disable-next-line no-console
      console.error('Error parsing user details:', error);
    }
    return null;
  };

  const userRole = getUserRole();
  const isSupportUser = userRole === 'SUPPORT';

  useEffect(async () => {
    setTimeout(() => {
      const activeNavLink = document.querySelector('.leftContainer ul .nav-item a.nav-link.active');
      if (activeNavLink) {
        activeNavLink.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'center'
        });
      }
    }, 0);
  }, []);

  return (
    <div className={`leftPanel ${!isLeftMenuVisible && isMobileView ? 'd-none' : ''}`}>
      <header>
        <img className="logo" src={logo} alt="logo" />
        <img className="copy" src={drawerIcon} alt="logo" />
      </header>

      <div className="leftContainer">
        <button type="button" className="close" aria-hidden="true" onClick={leftMenuToggleHandler}>
          <span aria-hidden="true">&times;</span>
          <span className="sr-only">Close</span>
        </button>

        {!isSupportUser && (
          <>
            <h2 className="mt-4">Payments</h2>
            <ul>
              <li className="nav-item">
                <NavLink exact to={AppConstants.routes.admin.affiliate.payments.summary} className='nav-link' activeClassName='active'>
                  <img src={homeIcon} alt="" />Summary
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink exact to={AppConstants.routes.admin.affiliate.payments.overdue} className='nav-link' activeClassName='active'>
                  <img src={overdueIcon} alt="" /> Overdue
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink exact to={AppConstants.routes.admin.affiliate.payments.upcoming} className='nav-link' activeClassName='active'>
                  <img src={eyeIcon} alt="" /> Upcoming
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink exact to={AppConstants.routes.admin.affiliate.payments.future} className='nav-link' activeClassName='active'>
                  <img src={futureIcon} alt="" /> Future
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink exact to={AppConstants.routes.admin.affiliate.payments.paid} className='nav-link' activeClassName='active'>
                  <img src={paidIcon} alt="" /> Paid
                </NavLink>
              </li>
            </ul>
          </>
        )}

        <h2 className="mt-4">Users</h2>
        <ul>
          <li className="nav-item">
            <NavLink exact to={AppConstants.routes.admin.dashboard} className='nav-link' activeClassName='active'>Recent Profiles</NavLink>
          </li>
          <li className="nav-item">
            <NavLink exact to={AppConstants.routes.admin.requested_info_profiles} className='nav-link' activeClassName='active'>Requested Info</NavLink>
          </li>
          {!isSupportUser && (
            <>
              <li className="nav-item">
                <NavLink exact to={AppConstants.routes.admin.all_profiles} className='nav-link' activeClassName='active'>All Profiles</NavLink>
              </li>
              <li className="nav-item">
                <NavLink exact to={AppConstants.routes.admin.premium_profiles} className='nav-link' activeClassName='active'>Premium Profiles</NavLink>
              </li>
            </>
          )}
          <li className="nav-item">
            <NavLink exact to={AppConstants.routes.admin.approved_profiles} className='nav-link' activeClassName='active'>Approved</NavLink>
          </li>
          {!isSupportUser && (
            <>
              <li className="nav-item">
                <NavLink exact to={AppConstants.routes.admin.suspended_profiles} className='nav-link' activeClassName='active'>Suspended</NavLink>
              </li>
              <li className="nav-item">
                <NavLink exact to={AppConstants.routes.admin.hidden_profiles} className='nav-link' activeClassName='active'>Hidden</NavLink>
              </li>
              <li className="nav-item">
                <NavLink exact to={AppConstants.routes.admin.rejected_profiles} className='nav-link' activeClassName='active'>Rejected</NavLink>
              </li>
              <li className="nav-item">
                <NavLink exact to={AppConstants.routes.admin.deleted_profiles} className='nav-link' activeClassName='active'>Deleted</NavLink>
              </li>
            </>
          )}
        </ul>

        {/* HIDDEN FOR NOW: the AFFILIATES section is switched off until
            affiliates are shown again. Restore by uncommenting this block
            and the icon imports above.
        <h2 className="mt-4">AFFILIATES</h2>
        <ul>
          <li className="nav-item">
            <NavLink exact to={AppConstants.routes.admin.affiliate.recent_profiles} className='nav-link' activeClassName='active'>
              <img src={recentProfileIcon} alt="" /> Recent Profiles
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink exact to={AppConstants.routes.admin.affiliate.requested_info_profiles} className='nav-link' activeClassName='active'>
              <img src={requestedInfoIcon} alt="" /> Requested Info
            </NavLink>
          </li>
          {!isSupportUser && (
            <li className="nav-item">
              <NavLink exact to={`${AppConstants.routes.admin.affiliate.all_profiles}`} className='nav-link' activeClassName='active'>
                <img src={eyeIcon} alt="" /> All Profiles
              </NavLink>
            </li>
          )}
          <li className="nav-item">
            <NavLink exact to={AppConstants.routes.admin.affiliate.approved_profiles} className='nav-link' activeClassName='active'>
              <img src={approvedIcon} alt="" /> Approved
            </NavLink>
          </li>
          {!isSupportUser && (
            <>
              <li className="nav-item">
                <NavLink exact to={AppConstants.routes.admin.affiliate.suspended_profiles} className='nav-link' activeClassName='active'>
                  <img src={suspendedIcon} alt="" /> Suspended
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink exact to={AppConstants.routes.admin.affiliate.rejected_profiles} className='nav-link' activeClassName='active'>
                  <img src={deleteIcon} alt="" /> Rejected
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink exact to={AppConstants.routes.admin.affiliate.deleted_profiles} className='nav-link' activeClassName='active'>
                  <img src={rejectedIcon} alt="" /> Deleted
                </NavLink>
              </li>
            </>
          )}
        </ul>
        */}

        <ul>
          <li className="nav-item">
            <div className="nav-link sign_out" role="button" aria-hidden="true" onClick={() => { logoutAdmin(history); }}>
              <img title="Logout" src={logoutIcon} alt="Logout" /> Logout
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default AdminLeftMenu;
